<template>
    <v-container>
        <v-row class="contentRow">
            <v-col>
                <h1 class="text-left darkColor--text">Onsite Supplier View</h1>
			</v-col>
			<v-col cols="12">
				<p class="darkColor--text">
					This is your overview of pending onsite-audits.
					Pending audits and pending improvements await your attention.
					<br />Completed audits have been submitted, you will not be notified of any future status changes.
				</p>
			</v-col>
            <v-tabs background-color="transparent" light centered icons-and-text>
                <v-tab>
                    Pending
                    <v-icon>fas fa-history fa-flip-horizontal</v-icon>
                </v-tab>
				<v-tab>
                    Improvements
					<v-icon>fas fa-building-circle-check</v-icon>
                </v-tab>
                <v-tab class="submitted">
                    Completed
                    <v-icon>fas fa-check</v-icon>
                </v-tab>
                <v-tab-item>
					<br />
                    <v-card elevation="0" outlined>
                        <v-card-title class="text-center justify-left py-6">
                            <h3 class="darkColor--text">Pending Onsite-Audits</h3>
                        </v-card-title>
                        <v-data-table
                            :loading="loading"
                            theme--
                            light
                            :headers="headersPending"
                            :items="pendingaudits"
                            :items-per-page="20"
                            class="light table mx-4 pending-table"
							:footer-props="{
						'items-per-page-options': [5, 10, 15]
					}"
                        >
							<template v-slot:item.onsiteDate="{ item }">
								<span v-if="item.visitDays && item.onsiteDate">
									{{ item.onsiteDate }}
									<v-tooltip top>
										<template v-slot:activator="{ on, attrs }">
											<span
												v-bind="attrs"
												v-on="on"
												class="grey--text text--darken-1"
											>
												({{ item.visitDays }} days)
											</span>
										</template>
										<span>Number of visit days</span>
									</v-tooltip>
								</span>
								<span v-else>
									{{ item.onsiteDate }}
								</span>
							</template>
							<template v-slot:item.actions="{ item }">
                                <v-btn
                                    color="primary"
                                    label
                                    small
                                    @click="showHintDialog(item)"
                                >
                                    View
                                    <v-icon right small>far fa-eye</v-icon>
                                </v-btn>
                            </template>
							<template v-slot:item.schedule="{ item }">
								<v-btn
									v-if="item.hasSchedule"
									:to="'/auditonsite/onsiteauditor/schedule/'+item.id"
									color="primary"
									label
									small
								>
									View
									<v-icon right small>fas fa-eye</v-icon>
								</v-btn>
								<span v-else class="grey--text">No schedule</span>
							</template>
                        </v-data-table>
                        <br />
                    </v-card>
                    <br />
                </v-tab-item>
				<v-tab-item>
					<br />
					<v-card elevation="0" outlined>
						<v-tabs background-color="transparent" color="orangeButton">
							<v-tab>
								Pending
							</v-tab>
							<v-tab>
								Completed
							</v-tab>
							<v-tab-item>
								<v-card elevation="0">
									<v-card-title class="text-center justify-left py-6">
										<h3 class="darkColor--text">Pending Improvements and Nonconformities</h3>
									</v-card-title>
									<v-data-table
										:loading="loading"
										theme--
										light
										:headers="headersImpro"
										:items="pendingImprovements"
										no-data-text="No available data"
										:items-per-page="20"
										class="light table mx-4 pending-table"
										:footer-props="{
											'items-per-page-options': [5, 10, 15]
										}"
									>
										<template v-slot:item.onsiteDate="{ item }">
											<span v-if="item.visitDays && item.onsiteDate">
												{{ item.onsiteDate }}
												<v-tooltip top>
													<template v-slot:activator="{ on, attrs }">
														<span
															v-bind="attrs"
															v-on="on"
															class="grey--text text--darken-1"
														>
															({{ item.visitDays }} days)
														</span>
													</template>
													<span>Number of visit days</span>
												</v-tooltip>
											</span>
											<span v-else>
												{{ item.onsiteDate }}
											</span>
										</template>
										<template v-slot:item.actions="{ item }">
											<v-btn
												color="primary"
												label
												small
												:to="'/auditonsite/onsitesupplier/'+item.id+'/improvements'"
											>
												Complete
												<v-icon right small>fas fa-pencil-alt</v-icon>
											</v-btn>
										</template>
									</v-data-table>
									<br />
								</v-card>
							</v-tab-item>
							<v-tab-item>
								<v-card elevation="0">
									<v-card-title class="text-center justify-left py-6">
										<h3 class="darkColor--text">Completed Improvements and Nonconformities</h3>
									</v-card-title>
									<v-data-table
										:loading="loading"
										theme--
										light
										:headers="headersImpro"
										:items="completedImprovements"
										no-data-text="No available data"
										:items-per-page="20"
										class="light table mx-4 completed-table"
										:footer-props="{
											'items-per-page-options': [5, 10, 15]
										}"
									>
										<template v-slot:item.onsiteDate="{ item }">
											<span v-if="item.visitDays && item.onsiteDate">
												{{ item.onsiteDate }}
												<v-tooltip top>
													<template v-slot:activator="{ on, attrs }">
														<span
															v-bind="attrs"
															v-on="on"
															class="grey--text text--darken-1"
														>
															({{ item.visitDays }} days)
														</span>
													</template>
													<span>Number of visit days</span>
												</v-tooltip>
											</span>
											<span v-else>
												{{ item.onsiteDate }}
											</span>
										</template>
										<template v-slot:item.actions="{ item }">
											<v-btn
												color="primary"
												label
												small
												:to="'/auditonsite/onsitesupplier/'+item.id+'/improvements'"
											>
												View
												<v-icon right small>far fa-eye</v-icon>
											</v-btn>
										</template>
									</v-data-table>
									<br />
								</v-card>
							</v-tab-item>
						</v-tabs>
					</v-card>
					<br />
				</v-tab-item>
                <v-tab-item>
                    <br />
                    <v-card elevation="0" outlined>
                        <v-card-title class="text-center justify-left py-6">
                            <h3 class="darkColor--text">Completed Onsite-Audit Requests</h3>
                        </v-card-title>
                        <v-data-table
                            :loading="loading"
                            theme--
                            light
                            :headers="headersCompleted"
                            :items="completedaudits"
                            :items-per-page="20"
                            class="light table mx-4 completed-table"
							:footer-props="{
						'items-per-page-options': [5, 10, 15]
					}"
                        >
							<template v-slot:item.onsiteDate="{ item }">
								<span v-if="item.visitDays && item.onsiteDate">
									{{ item.onsiteDate }}
									<v-tooltip top>
										<template v-slot:activator="{ on, attrs }">
											<span
												v-bind="attrs"
												v-on="on"
												class="grey--text text--darken-1"
											>
												({{ item.visitDays }} days)
											</span>
										</template>
										<span>Number of visit days</span>
									</v-tooltip>
								</span>
								<span v-else>
									{{ item.onsiteDate }}
								</span>
							</template>
							<template v-slot:item.status="{ item }">
								<span
									:class="{
										'trace--text': item.status === 'Pending',
										'primary--text': item.status === 'Approved',
										'warning--text': item.status === 'Conditionally Approved',
										'red--text': item.status === 'Denied'
									}"
								>
									{{ item.status }}
								</span>
							</template>
							<template v-slot:item.schedule="{ item }">
								<v-btn
									v-if="item.hasSchedule"
									color="primary"
									small
									@click="showSchedule(item.id)"
								>
									View
									<v-icon right small>far fa-eye</v-icon>
								</v-btn>
								<span v-else class="grey--text">No schedule</span>
							</template>
                        </v-data-table>
                        <br />
                    </v-card>
                </v-tab-item>
            </v-tabs>
        </v-row>
		<v-dialog v-model="dialogHint" max-width="500">
            <v-card style="border: 1px solid black;">
                <v-card-title>Onsite Audit Scope:</v-card-title>
                <v-card-text>
                    <div v-if="selectedItem">
                        <p v-if="selectedItem.hint"><strong>Objective and Scope:</strong> {{ selectedItem.hint }}</p>
						<p v-else><i>There is no any details about your onsite-Audit</i></p>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="dialogHint = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
		<v-dialog v-model="viewSchedule" max-width="60%">
			<v-card style="border: 1px solid black; padding: 5px 15px;">
				<v-card-actions>
					<p color="primary">Onsite-Audit Template :- {{ (completedaudits.find(a => a.id === auditId) || {}).template || '' }}</p>
					<v-spacer />
					<v-btn icon color="primary" @click="viewSchedule = false"><v-icon>fas fa-times</v-icon></v-btn>
				</v-card-actions>
				<div class="contentRow" style="border: 5px solid #4CAF50">
					<v-col>
						<h3>Auditor Schedule</h3>
					</v-col>
					<v-col cols="12">
						<v-simple-table>
							<thead>
								<tr>
								<th class="headers">Number</th>
								<th class="headers">Date</th>
								<th class="headers">Time</th>
								<th class="headers">Place</th>
								<th class="headers">Examination</th>
								</tr>
							</thead>
							<tbody>
								<tr v-if="schedule.length === 0">
									<td colspan="6" class="text-center">No auditor schedule is available.</td>
								</tr>
								<template v-else>
									<tr v-for="(entry, index) in schedule" :key="index">
										<td><p>{{ index + 1 }}</p></td>
										<td><p>{{ formatDate(entry.Date) }}</p></td>
										<td><p>{{ displayValue(entry.Time) }}</p></td>
										<td><p>{{ displayValue(entry.Place) }}</p></td>
										<td><p>{{ displayValue(entry.Examination) }}</p></td>
									</tr>
								</template>
							</tbody>
						</v-simple-table>
					</v-col>
				</div>
			</v-card>
		</v-dialog>
    </v-container>
</template>

<script>
import AuditRequestsAPI from "../../api/audit/request"
import AuditsAPI from "../../api/audit/audit"
import LoadingState from "../../consts/LoadingState"
import { mapGetters } from "vuex"
export default {
	name: "AuditorAuditOnsiteOverview",

	data() {
		return {
			headersPending: [
				{
					text: "Sender",
					value: "sender",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Auditor",
					value: "auditorName",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Timestamp",
					value: "timestamp",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Onsite-Date",
					value: "onsiteDate",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Onsite-Audit Template",
					value: "template",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Objective & Scope",
					value: "actions",
					sortable: false,
					align: "center",
					class: "darkColor--text"
				},
				{
					text: "Schedule",
					value: "schedule",
					sortable: false,
					align: "center",
					class: "darkColor--text"
				}
			],
			headersImpro: [
				{
					text: "Sender",
					value: "sender",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Auditor",
					value: "auditorName",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Timestamp",
					value: "timestamp",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Onsite-Date",
					value: "onsiteDate",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Onsite-Audit Template",
					value: "template",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Details",
					value: "actions",
					sortable: false,
					align: "center",
					class: "darkColor--text"
				}
			],
			headersCompleted: [
				{
					text: "Sender",
					value: "sender",
					sortable: false,
					class: "darkColor--text",
					width: "100px"
				},
				{
					text: "Auditor",
					value: "auditorName",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Timestamp",
					value: "timestamp",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Onsite-Date",
					value: "onsiteDate",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Audit Template",
					value: "template",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Auditor Schedule",
					value: "schedule",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Status",
					value: "status", 
					sortable: false,
					class: "darkColor--text"
				},
			],

			pendingaudits: [],
			completedaudits: [],
			id: false,
			client: false,
			timestamp: false,
			template: false,
			dialogDelete: false,
			loading: false,
			status: 0,
			selectedItem: null,
			dialogHint: false,
			viewSchedule: false,
			schedule: [],
			auditId: null,
			pendingImprovements: [],
			completedImprovements: [],
			newRequestID: null,
		}
	},
	mounted() {
		this.loadPendingAudits()
		this.loadCompletedAudits()
		this.loadImprovements()
	},
	computed: {
		...mapGetters("user", ["isLoggedIn", "getUser"]),
		clientName() {
			return this.getUser.clientID
		},
	},
	methods: {
		displayValue(val) {
			return val === null || val === undefined || val === "" ? "-" : val
		},
		showHintDialog(item) {
			this.selectedItem = item
			this.dialogHint = true
		},
		showSchedule(id) {
			this.auditId = id
			this.viewSchedule = true
			this.loadSchedule(id, true)
		},
		async loadCompletedAudits() {
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)
			
			try {
				const result = await AuditsAPI.onsiteSupplierList({})
				this.completedaudits = []
				
				// Create an array of promises for checking schedules
				const auditPromises = result.items.map(async (entry) => {
					let onsiteDate
					if(entry.fromDate && entry.toDate){
						onsiteDate = this.$moment(entry.fromDate).format("DD/MM/YYYY") + " - " + this.$moment(entry.toDate).format("DD/MM/YYYY")
					}else if(entry.fromDate){
						onsiteDate = this.$moment(entry.fromDate).format("DD/MM/YYYY")
					}else if(entry.toDate){
						onsiteDate = this.$moment(entry.toDate).format("DD/MM/YYYY")
					}

					const statusname = {
						0: "Pending",
						1: "Approved",
						2: "Conditionally Approved",
						3: "Denied"
					}

					// Check if schedule exists
					let hasSchedule = false
					try {
						const scheduleId = entry.newRequest || entry.id
						const scheduleResult = await AuditsAPI.getSchedule(scheduleId)
						hasSchedule = scheduleResult && scheduleResult.length > 0
					} catch (error) {
						hasSchedule = false
					}

					return {
						id: entry.id,
						sender: entry.recipientName,
						timestamp: this.$moment(entry.timestamp).format("DD/MM/YYYY HH:mm:ss"),
						template: entry.templateName,
						auditorName: entry.senderName,
						onsiteDate: onsiteDate,
						visitDays: entry.visitDays,
						status: statusname[entry.status],
						view: null,
						newRequestID: entry.newRequest,
						hasSchedule: hasSchedule
					}
				})
				
				// Wait for all schedule checks to complete
				this.completedaudits = await Promise.all(auditPromises)
				
				this.$store.dispatch(
					"loading/" + LoadingState.ACTION_END_LOADING,
					null,
					{ root: true }
				)
			} catch (reason) {
				this.$store.dispatch(
					"loading/" + LoadingState.ACTION_SET_ERROR,
					reason,
					{ root: true }
				)
			}
		},
		async loadPendingAudits() {
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)
			
			try {
				const result = await AuditRequestsAPI.onsiteList({type:"incoming"})
				this.pendingaudits = []
				
				// Create an array of promises for checking schedules
				const auditPromises = result.items.map(async (entry) => {
					let onsiteDate
					if(entry.fromDate && entry.toDate){
						onsiteDate = this.$moment(entry.fromDate).format("DD/MM/YYYY") + " - " + this.$moment(entry.toDate).format("DD/MM/YYYY")
					}else if(entry.fromDate){
						onsiteDate = this.$moment(entry.fromDate).format("DD/MM/YYYY")
					}else if(entry.toDate){
						onsiteDate = this.$moment(entry.toDate).format("DD/MM/YYYY")
					}
					
					// Check if schedule exists for this request ID
					let hasSchedule = false
					try {
						const scheduleResult = await AuditsAPI.getSchedule(entry.requestID)
						hasSchedule = scheduleResult && scheduleResult.length > 0
					} catch (error) {
						hasSchedule = false
					}
					
					return {
						id: entry.requestID,
						sender: entry.senderName,
						timestamp: this.$moment(entry.timestamp).format("DD/MM/YYYY HH:mm:ss"),
						template: entry.templateName,
						auditorName: entry.auditorName,
						onsiteDate: onsiteDate,
						visitDays: entry.visitDays,
						hint: entry.hint,
						hasSchedule: hasSchedule
					}
				})
				
				// Wait for all schedule checks to complete
				this.pendingaudits = await Promise.all(auditPromises)
				
				this.$store.dispatch(
					"loading/" + LoadingState.ACTION_END_LOADING,
					null,
					{ root: true }
				)
			} catch (reason) {
				this.$store.dispatch(
					"loading/" + LoadingState.ACTION_SET_ERROR,
					reason,
					{ root: true }
				)
			}
		},
		loadImprovements() {
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)
			AuditsAPI.getImprovements()
				.then(result => {
					this.pendingImprovements = []
					this.completedImprovements = []
					const seenIds = new Set()

					result.sort((a, b) => new Date(b.Timestamp) - new Date(a.Timestamp))

					for (let entry of result) {
						if (entry.Recipient === this.clientName){
							if(seenIds.has(entry.AuditID)) continue
							seenIds.add(entry.AuditID)

							let onsiteDate
							if (entry.FromDate && entry.ToDate) {
								onsiteDate = this.$moment(entry.FromDate).format("DD/MM/YYYY") + " - " + this.$moment(entry.ToDate).format("DD/MM/YYYY")
							} else if (entry.FromDate) {
								onsiteDate = this.$moment(entry.FromDate).format("DD/MM/YYYY")
							} else if (entry.ToDate) {
								onsiteDate = this.$moment(entry.ToDate).format("DD/MM/YYYY")
							}

							const improvementItem = {
								id: entry.AuditID,
								sender: entry.SenderName,
								auditorName: entry.AuditorName,
								timestamp: this.$moment(entry.Timestamp).format("DD/MM/YYYY"),
								onsiteDate: onsiteDate,
								visitDays: entry.visitDays,
								template: entry.TemplateName,
								answer: entry.Answer
							}

							// Check if any improvement has null answer for this audit ID
							const hasNullAnswer = result.some(item => 
								item.AuditID === entry.AuditID && 
								item.Recipient === this.clientName && 
								item.Answer === null
							)

							if (hasNullAnswer) {
								this.pendingImprovements.push(improvementItem)
							} else {
								this.completedImprovements.push(improvementItem)
							}
						}
					}
					
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						null,
						{ root: true }
					)
				})
				.catch(reason => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						reason,
						{ root: true }
					)
				})
		},
		loadSchedule(requestId, useNewRequestId = false) {
			let id = requestId || this.auditId
			if (useNewRequestId) {
				const audit = this.completedaudits.find(a => a.id === id)
				id = audit?.newRequestID || id
			}
			AuditsAPI.getSchedule(id)
				.then((result) => {
					this.schedule = result || []
				})
				.catch((reason) => {
					this.schedule = []
					console.error("Error loading schedule:", reason)
				})
		},
		formatDate(timestamp) {
			return timestamp ? this.$moment(timestamp).format("YYYY-MM-DD") : "-"
		},
	}
}
</script>
<style>
.completed-table thead th {
    font-size: 14px !important;
}
.pending-table thead th {
    font-size: 14px !important;
}
</style>
